/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
import Title from 'material/copy/title/title';
import Toggle from 'material/toggle/toggle';
import ToolTip from 'material/message/tooltip/tooltip';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/ads/placement/incontent/incontent_placement_styles';



/* ========== ~~~~~~~~~~ PAGE : ADs : IN CONTENT PLACEMENT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class InContentPlacement extends Component {
    handleToggle = (toggledAd) => {
        const currentAdsState = this.props.embedStatus.ads.desktop;
        const newAdsState = { ad1: currentAdsState.ad1, overlay: currentAdsState.overlay, ad2: currentAdsState.ad2 };
        switch (toggledAd) {
            case 'ads':
                if(currentAdsState.overlay) {
                    newAdsState.overlay = false;
                } else {
                    newAdsState.overlay = true;
                }
                break;
            case 'overlayAds':
            default:
                if (currentAdsState.overlay) {
                    newAdsState.ad1 = true;
                    newAdsState.ad2 = true;
                    newAdsState.overlay = false;
                } else {
                    newAdsState.ad1 = true;
                    newAdsState.ad2 = true;
                    newAdsState.overlay = true;
                }
        }
        // console.log(newAdsState);
        this.props.setAds(newAdsState.ad1, newAdsState.ad2, newAdsState.overlay);
    }
    checkToggleStatus = (adsPlacement) => {
        const adsState = this.props.embedStatus.ads.desktop;
        switch (adsPlacement) {
            case 'ads':
                return adsState['ad1'] && adsState['ad2'] && !adsState['overlay'] ? 'on' : 'off';
            case 'overlayAds':
                return adsState['ad1'] && adsState['ad2'] && adsState['overlay'] ? 'on' : 'off';
            default:
                return adsState[adsPlacement] ? 'on' : 'off';
        }
    }
    render() {
        return(
            <div className={`${this.props.classes.incontent} placement-location incontent`}>
                <Title>
                    <h3>Desktop</h3>
                </Title>
                <div className={`visual`}>
                    <div className={`device desktop`}>
                        <div className={`embed-container`}>
                            <ToolTip position={`right`} trigger={`click`} open delay={2500} content={`350px`}>
                                <div className={`embed`}>
                                    <div onClick={()=>this.handleToggle('overlayAds')} className={`embed-ads-group`}>
                                        <div className={`ad-left`}>
                                            <div className={`ad overlay ${this.checkToggleStatus('overlayAds')}`}>
                                                <div className={`group`}>
                                                    <div className={`desc`}>Overlay Ad</div>
                                                    <div className={`note`}>Will only appear <span className={`clump`}>15 Sec.</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`ad-right`}>
                                            <div className={`ad overlay ${this.checkToggleStatus('overlayAds')}`}>
                                                <div className={`group`}>
                                                    <div className={`desc`}>Overlay Ad</div>
                                                    <div className={`note`}>Will only appear <span className={`clump`}>15 Sec.</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={'toggle-container'}>
                                            <Toggle handleClick={null} value={`overlayAds`} on={this.checkToggleStatus('overlayAds')} type={'switch'} variant={'secondary'} />
                                        </div>
                                    </div>
                                </div>
                            </ToolTip>
                            <ToolTip position={`right`} trigger={`click`} open delay={2500} content={`250px`}>
                                <div onClick={()=>this.handleToggle('ads')} className={`ads-group`}>
                                    <div className={`ad-left`}>
                                        <div className={`ad inline ${this.checkToggleStatus('ads')}`}>
                                            <div className={`group`}>
                                                <div className={`desc`}>Ad 1</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`ad-right`}>
                                        <div className={`ad inline ${this.checkToggleStatus('ads')}`}>
                                            <div className={`group`}>
                                                <div className={`desc`}>Ad 2</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'toggle-container'}>
                                        <Toggle handleClick={null} value={`ads`} on={this.checkToggleStatus('ads')} type={'switch'} variant={'secondary'} />
                                    </div>
                                </div>
                            </ToolTip>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(InContentPlacement);
